import React, { useState } from "react";
import MessagesEspañol from "../lang/es-ES.json";
import MessagesIngles from "../lang/en-US.json";
import MessagesPortugues from "../lang/pr-PR.json";
import MessagesItaliano from "../lang/it-IT.json";
import MessagesAleman from "../lang/al-AL.json";
import { IntlProvider, ReactIntlErrorCode } from "react-intl";

const langContext = React.createContext();

const DEFAULT_LOCALE = "es-ES";

// Mapea locale -> archivo de mensajes
const getMessagesFor = (locale) => {
  switch (locale) {
    case "en-US":
      return MessagesIngles;
    case "pr-PR":
      return MessagesPortugues;
    case "it-IT":
      return MessagesItaliano;
    case "al-AL":
      return MessagesAleman;
    case "es-ES":
    default:
      return MessagesEspañol;
  }
};

const LangProvider = ({ children }) => {
  // Lee localStorage en forma segura
  let storedLang = null;
  try {
    storedLang = localStorage.getItem("lang");
  } catch (_) {
    // en SSR o navegadores raros, ignoramos errores
  }

  // Si no hay guardado o es inválido, forzamos es-ES
  const initialLocale = ["es-ES", "en-US", "pr-PR", "it-IT", "al-AL"].includes(storedLang)
    ? storedLang
    : DEFAULT_LOCALE;

  const [locale, SetLocale] = useState(initialLocale);
  const [messages, SetMensajes] = useState(getMessagesFor(initialLocale));

  // Evita ruido por claves faltantes
  function onError(e) {
    if (
      e.code === ReactIntlErrorCode.MISSING_DATA ||
      e.code === ReactIntlErrorCode.MISSING_TRANSLATION
    ) {
      return;
    }
    // Podrías loguearlo si querés:
    // console.warn("[react-intl]", e);
  }

  const ChangeLanguage = (language) => {
    const nextLocale = ["es-ES", "en-US", "pr-PR", "it-IT", "al-AL"].includes(language)
      ? language
      : DEFAULT_LOCALE;

    SetMensajes(getMessagesFor(nextLocale));
    SetLocale(nextLocale);
    try {
      localStorage.setItem("lang", nextLocale);
    } catch (_) {}
  };

  return (
    <langContext.Provider value={{ ApplyLanguage: ChangeLanguage }}>
      {/* key=locale fuerza re-render limpio cuando cambia el idioma */}
      <IntlProvider key={locale} locale={locale} messages={messages} onError={onError}>
        {children}
      </IntlProvider>
    </langContext.Provider>
  );
};

export { langContext, LangProvider };
